import { validator } from "@/utils/validator";

export const masterDataSupportLanguageSchema = validator.object().shape({
  supportLanguageName: validator.string().trim().emptyToNull().label("言語名").required(),
  mainCountry: validator.string().trim().emptyToNull().label("主要な国").notRequired(),
});
